import React from 'react';
import { Popconfirm, Modal, Button, Row, Col, DatePicker, InputNumber, message, Tabs } from 'antd';
import ExportUtil from '../../common/ExportUtil';
import moment from 'moment';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import Sider from './PlanSider';
import TableC from '../basicElement/TableC';
import './style/plan.less';
import PlanChart from './PlanChart';

const { MonthPicker } = DatePicker;
const { TabPane } = Tabs;
const monthFormat = 'YYYY-MM';

class Investigation extends React.Component {
    state = {
        loading: false,
        plan: {},
        monthlyPlan: [],
        planIndex: 1,
        invPlanIsEdit: false,/*整体计划是否处于编辑状态*/
        pagination: {
            current: 1,
            pageSize: 10,
        },
        activeKey:'Type_Random',
        visitGroupingId: '',
        visitGroupingList: [],
        failterRoteModal: false,
        showChart: true,
        isGivenSecondLines: false,
        isGivenInvStage: false,
        isShowInvPlan: false,
        blindInvId: '',
        secondLines: '',
        showAccumulation: false,
        givenSecondLinesCanEdit: false,  //特殊执行业务线二级分类，判断是否可编辑
    }

    componentDidMount() {
        const { curRole, investigationSiteName  } = sessionStorage;
        const { secondLines, blindInvId } = this.state;
        const showOperator = !(secondLines === '非盲' && !!blindInvId);
        if(showOperator)
        {
            const _this =this;
            Modal.confirm({
                title: '请先配置本项目的访视周期计划！',
                content: '',
                cancelText:'已完成配置',
                okText:'好的,现在去配置',
                onOk(){
                    _this.canEditByInvStatus(()=>{
                        sessionStorage.investigationSiteName = '';
                        location.href = `./#/executeMgr/visitPeriodPlan`; 
                        return;
                    })
                },
                onCancel(){
                   
                }
              });
        }
        const { activeKey } = this.state;
        this.beforeLoad(activeKey);
        this.queryInvestigationSecondLines();
    }

    queryInvestigationSecondLines = () => {
        //判断是否为执行业务线二级分类为“SSU主导、启动前协助、启动前协助+启动后常规CRC执行、启动后常规CRC执行、非盲”的项目
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationSecondLines,
            data: { invId },
            dataType: 'json',
            doneResult: res => {
                const { secondLines, sitePlanFteCal } = res;
                const givenSecondLines = ['SSU主导','启动前协助','启动前协助+启动后常规CRC执行','启动后常规CRC执行'];
                const isGivenSecondLines = givenSecondLines.includes(secondLines) && sitePlanFteCal;
                this.setState({
                    isGivenSecondLines,
                    secondLines,
                    sitePlanFteCal,
                });
            }
        };
        $.sendRequest(options);
    }

    queryBlindInvestigation = () => {
        const options = {
            method: 'POST',
            url: API_URL.plan.queryBlindInvestigation,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { isBlind, secondLines, blindInvId } = res;
                const isShowInvPlan = isBlind && secondLines === '非盲';
                this.setState({
                    isShowInvPlan,
                    blindInvId,
                },() => {
                    this.queryVisitGrouping();
                });
            },
        };
        $.sendRequest(options);
    }


    beforeLoad = (activeKey) => {
        this.setState({
            activeKey,
        }, () => {
            this.queryBlindInvestigation();
        });
        this.queryInvestigationStageByInvId();
    }

    queryVisitGrouping = () => {
        const { blindInvId } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.plan.queryVisitGrouping,
            data: {blindInvId},
            dataType: 'json',
            doneResult: res => {
                if ( res && res.data.length <= 0) {
                    return
                }
                this.setState({
                    visitGroupingList: res.data,
                    visitGroupingId:String(res.data[0].visitGroupingId) 
                }, () => {
                    this.loadData();
                });
            },
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { activeKey, visitGroupingId, blindInvId } = this.state;
        this.setState({ loadingData: true });
        const options = {
            url: `${API_URL.plan.invDataList}`,
            data: { statisticalType:activeKey,visitGroupingId, blindInvId },
            dataType: 'json',
            doneResult: (data => {
                const { monthlyPlan, planIndex } = this.state;
                if (monthlyPlan && monthlyPlan.length > 0) {
                    monthlyPlan.splice(0, monthlyPlan.length);
                }
                let curIndex = planIndex;
                data.data.monthlyPlan.map((item, i) => {
                    monthlyPlan.push({
                        planIndex: curIndex,
                        investigationMonthlyPlanId: item.investigationMonthlyPlanId,
                        yearMonth: moment(item.year * 100 + item.month, "YYYYMM"),
                        planAmount: item.planAmount,
                        monthlyPlanIsEditing: false,
                        year : item.year,
                        month : item.month,
                    });
                    curIndex = curIndex + 1;
                });
                const startDate = data.data.startDate || {};
                const plan = data.data.plan || {};
                const {  batchLeftMonth,batchLeftYear,batchPlanAmount,batchRightMonth,batchRightYear, planAmount} = plan ||{};
                const { contractRandomPlanAmount, firstStartSiteDate, invPlanBeginDate, invPlanEndDate, lastStartSiteDate} = startDate || {};
                if(!batchLeftYear)
                {
                    if(firstStartSiteDate){
                        plan.batchLeftYear = moment(firstStartSiteDate).year();
                        plan.batchLeftMonth = moment(firstStartSiteDate).month() + 1;
                    }
                    else{
                        plan.batchLeftYear = moment().year();
                        plan.batchLeftMonth = moment().month() + 1;
                    }

                }
                if(!batchRightYear){
                    if(invPlanEndDate)
                    {
                        plan.batchRightYear = moment(invPlanEndDate).year();
                        plan.batchRightMonth = moment(invPlanEndDate).month() + 1;
                    }
                }
                this.setState({
                    loadingData: false,
                    plan,
                    startDate,
                    monthlyPlan,
                    contractRandomPlanAmount,
                    planIndex: curIndex,
                    oldFilterFailureRate:data.data.plan.filterFailureRate,
                },()=>this.reRenderChart());
            }
            ),
        };
        $.sendRequest(options);
    }

    editInvPlan = () => {
        const { invPlanIsEdit, plan, activeKey, visitGroupingId, contractRandomPlanAmount } = this.state;
        if (invPlanIsEdit) {
            if(plan.planAmount === undefined || plan.planAmount === null) {
                return message.warning('总计划数不能为空，请重新输入');
            }
            // if(plan.planAmount < this.getTotalAmount()){
            //     return message.error('修改的计划数不能小于所有月度计划总和');
            // }
            // if (contractRandomPlanAmount && contractRandomPlanAmount !== 0 && (plan.planAmount > contractRandomPlanAmount)) {
            //     Modal.confirm({
            //         iconType: 'exclamation-circle',
            //         title: '',
            //         content: '津石入组总计划数＞合同计划随机（入组）数，请确认是否需要调整合同计划随机（入组）数',
            //         onOk: () => {
            //             this.saveTotalPlannedNumber({
            //                 activeKey, 
            //                 planAmount: plan.planAmount, 
            //                 visitGroupingId,
            //             });
            //             this.modifyContractRandomPlanAmount();
            //         },
            //         onCancel: () => {
            //             this.saveTotalPlannedNumber({
            //                 activeKey, 
            //                 planAmount: plan.planAmount, 
            //                 visitGroupingId,
            //             });
            //         }
            //     })
            // } else {
                this.saveTotalPlannedNumber({
                    activeKey, 
                    planAmount: plan.planAmount, 
                    visitGroupingId,
                });
            // }
            
        } else {
            this.setState({ invPlanIsEdit: true });
        }
    }

    modifyContractRandomPlanAmount = () => {
        const { plan} = this.state;
        const options = {
            url: API_URL.plan.modifyContractRandomPlanAmount,
            data: { planAmount: plan.planAmount,  },
            dataType: 'json',
            doneResult: () => {
                
            },
        };
        $.sendRequest(options);
    }

    // 保存总计划数
    saveTotalPlannedNumber = (params) => {
        const { activeKey, planAmount, visitGroupingId } = params;
        const options = {
            url: API_URL.plan.modifyPlan,
            data: {
                activeKey,
                planAmount,
                visitGroupingId,
            },
            dataType: 'json',
            doneResult: () => {
                this.setState({ invPlanIsEdit: false }, () => {
                    this.loadData();
                });
            },
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const isGivenInvStage = (data || []).some(el => el.typeValue == '准备期' || el.typeValue == '筛选入组期');
                this.setState({
                    invStageList: data,
                    isGivenInvStage,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    onSelectMonth = (planIndex, moment) => {
        const { monthlyPlan } = this.state;
        monthlyPlan.map((plan, i) => {
            if (plan.planIndex == planIndex) {
                plan.yearMonth = moment;
            }
        });
        this.setState({ monthlyPlan });
    }

    onSelectJoinGroupMonth = (value,modal) => { 
        const { plan } = this.state;
        if(modal == 'startDate')
        {
            plan.batchLeftMonth = value.month() + 1;
            plan.batchLeftYear = value.year();
        } else if(modal == 'endDate'){
            plan.batchRightMonth = value.month() + 1;
            plan.batchRightYear = value.year();
        }
        this.setState({ plan });
    }
    onInputPlanAmount = value => {
        const { plan } = this.state;
        plan.planAmount = value;
        this.setState({ plan });
    }

    onInputBatchPlanAmount = value => {
        const { plan } = this.state;
        plan.batchPlanAmount = value;
        this.setState({ plan });
    }

    onInputMonthPlan = (planIndex, value) => {
        const { monthlyPlan } = this.state;
        monthlyPlan.map((plan, i) => {
            if (plan.planIndex == planIndex) {
                plan.planAmount = value;
            }
        });
        this.setState({ monthlyPlan });
    }

    getTotalAmount = () => {
        const { monthlyPlan } = this.state;
        let totalAmount = 0;
        monthlyPlan.map((plan, i) => {
            if (plan.planAmount) {
                totalAmount += plan.planAmount;
            }
        });
        return totalAmount;
    }

    getLastVal = () => {
        const { monthlyPlan, startDate } = this.state;
        const { firstStartSiteDate, invPlanBeginDate, invPlanEndDate, lastStartSiteDate } = startDate || {};
        let lastMonth = moment().add("month", -1);
        if(!monthlyPlan.length)
        {
            if(firstStartSiteDate){
                lastMonth = moment(firstStartSiteDate).add("month", -1);
            }
        }
        const lastVal = {
            lastMonth,//: moment().add("month", -1),
            planAmount: ''
        }
        if (monthlyPlan.length) {
            monthlyPlan.map((val, index) => {
                if (val.yearMonth) {
                    lastVal.lastMonth = val.yearMonth
                }
                lastVal.planAmount = val.planAmount
            })
        }
        return lastVal;
    }

    addMonthly = () => {
        const { monthlyPlan, planIndex, plan, isGivenSecondLines } = this.state;
        const lastVal = this.getLastVal();
        const {
            planAmount,
            batchRightMonth,
            batchRightYear,
        } = plan ||{};
        const yearMonth = moment(lastVal.lastMonth).add(1, 'M');
        const batchRightYearMonth = moment(`${batchRightYear}-${batchRightMonth}`);
        if (isGivenSecondLines && yearMonth > batchRightYearMonth) {
            return;
        }
        if(!planAmount){
            message.error('未设置项目计划数，不可设置入组周期每月计划');
            return; 
        }
        monthlyPlan.push({
            planIndex,
            yearMonth: moment(lastVal.lastMonth).add(1, 'M'),
            planAmount: lastVal.planAmount,
            monthlyPlanIsEditing: false,
            isAdd:true,
        });
        this.setState({
            monthlyPlan,
            planIndex: planIndex + 1,
        });
    }

    // 入组周期 的添加更新
    addUpdateMonthly =()=> {
        const { plan, visitGroupingId, startDate, isGivenSecondLines } = this.state;
        const {  batchLeftMonth,batchLeftYear,batchPlanAmount,batchRightMonth,batchRightYear, planAmount} = plan ||{};
        const { firstStartSiteDate, invPlanBeginDate, invPlanEndDate, lastStartSiteDate } = startDate || {};
        if(!(batchLeftYear && batchLeftMonth))
        {
            message.error('请设置入组周期的开始时间');
            return; 
        }
        if(!(batchRightYear && batchRightMonth))
        {
            message.error('请设置入组周期的结束时间');
            return; 
        }
        if(!planAmount){
            message.error('未设置项目计划数，不可设置入组周期每月计划');
            return; 
        }
        if (!isGivenSecondLines) {
            if(firstStartSiteDate){
                if(moment(`${batchLeftYear}-${batchLeftMonth}`,'YYYY-MM') < moment(firstStartSiteDate,'YYYY-MM')){
                    message.error('项目随机（入组）计划月份不可小于中心计划启动月份');
                    return;
                }
            }else{
                if(moment(`${batchLeftYear}-${batchLeftMonth}`,'YYYY-MM') < moment(invPlanBeginDate,'YYYY-MM')){
                    message.error('项目随机（入组）计划月份不可小于项目计划开始月份');
                    return;
                }
            }
            if(!invPlanBeginDate){
                if(moment(`${batchRightYear}-${batchRightMonth}`,'YYYY-MM') > moment(invPlanEndDate,'YYYY-MM')){
                    message.error('项目随机（入组）计划月份不可大于项目计划结束月份');
                    return;
                }
            }
        }

        const options = {
            method: 'POST',
            url: API_URL.plan.batchSet,
            data: { 
                leftMonth:batchLeftMonth,
                leftYear:batchLeftYear,
                planAmount:batchPlanAmount,
                rightMonth:batchRightMonth,
                rightYear:batchRightYear,
                visitGroupingId,
             },
            dataType: 'json',
            doneResult: res => {
                if(res && res.error)
                {
                    message.error('添加更新失败');
                    return;
                }
                message.success('添加更新成功');
                this.loadData();
            },
        };
        $.sendRequest(options);
    }

    saveMonthlyPlanRow = () => {
        const { monthlyPlan, activeKey, visitGroupingId, startDate, plan } = this.state;
        const { firstStartSiteDate, invPlanBeginDate, invPlanEndDate, lastStartSiteDate } = startDate || {};
        const {
            batchRightMonth,
            batchRightYear,
        } = plan ||{};
        const batchRightYearMonth = moment(`${batchRightYear}-${batchRightMonth}`);  //入组周期结束时间
        const sendParams = {};
        let errorMessage = '';
        if (monthlyPlan.length == 0) {
            message.warning('请添加计划数据');
            return
        }
        monthlyPlan.map((plan, i) => {
                sendParams[`monthlyPlanDtos[${i}].year`] = plan.yearMonth.year();
                sendParams[`monthlyPlanDtos[${i}].month`] = plan.yearMonth.month() + 1;
                sendParams[`monthlyPlanDtos[${i}].planAmount`] = plan.planAmount;
                // if (plan.monthlyPlanIsEditing) {
                    if (plan.yearMonth == null || plan.yearMonth == undefined) {
                        errorMessage = '计划时间为空或无效';
                        return;
                    }
                    if (plan.planAmount == null || plan.planAmount == undefined || plan.planAmount < 0) {
                        errorMessage = '计划数为空或无效';
                        return;
                    }
                    const curAddDate = moment(`${plan.yearMonth.year()}-${plan.yearMonth.month() + 1}`,'YYYY-MM');
                    if (curAddDate > batchRightYearMonth) {
                        errorMessage = '项目随机（入组）计划月份不可大于项目计划结束月份';
                        return;
                    }
                    // if(firstStartSiteDate){
                    //     if(curAddDate < moment(firstStartSiteDate,'YYYY-MM') && plan.isAdd){
                    //         // message.error('项目随机（入组）计划月份不可小于中心计划启动月份');
                    //         errorMessage = '项目随机（入组）计划月份不可小于中心计划启动月份';
                    //         return;
                    //     }
                    //     if(curAddDate > moment(invPlanEndDate,'YYYY-MM')){
                    //         // message.error('项目随机（入组）计划月份不可大于项目计划结束月份');
                    //         errorMessage = '项目随机（入组）计划月份不可大于项目计划结束月份';
                    //         return;
                    //     }
                    // }
                    // else{
                    //     if(curAddDate < moment(invPlanBeginDate,'YYYY-MM')){
                    //         // message.error('项目随机（入组）计划月份不可小于项目计划开始月份');
                    //         errorMessage = '项目随机（入组）计划月份不可小于项目计划开始月份';
                    //         return;
                    //     }
                    //     if(curAddDate > moment(invPlanEndDate,'YYYY-MM')){
                    //         // message.error('项目随机（入组）计划月份不可大于项目计划结束月份');
                    //         errorMessage = '项目随机（入组）计划月份不可大于项目计划结束月份';
                    //         return;
                    //     }
                    // }
                // }
        });

        if (errorMessage != '') {
            message.error(errorMessage);
            return
        }

        const options = {
            url: API_URL.plan.modifyMonthlyPlan,
            data: {
                statisticalType:activeKey,
                visitGroupingId,
                ...sendParams,
            },
            dataType: 'json',
            doneResult: () => {
                monthlyPlan.map(plan => {
                    plan.monthlyPlanIsEditing = false;
                });
                this.setState({ monthlyPlan, givenSecondLinesCanEdit: false }, () => {
                    this.loadData();
                });
            },
        };
        $.sendRequest(options);
    }

    saveDefinePlan = planIndex => {
        const { monthlyPlan, activeKey, visitGroupingId, startDate } = this.state;
        const { firstStartSiteDate, invPlanBeginDate, invPlanEndDate, lastStartSiteDate } = startDate || {};
        monthlyPlan.map((plan, i) => {
            if (plan.planIndex == planIndex) {
                if (plan.monthlyPlanIsEditing) {
                    if (plan.yearMonth == null || plan.yearMonth == undefined) {
                        Modal.error({ title: '计划时间为空或无效' });
                        return;
                    }
                    if (plan.planAmount == null || plan.planAmount == undefined || plan.planAmount < 0) {
                        Modal.error({ title: '计划数为空或无效' });
                        return;
                    }
                    const curAddDate = moment(`${plan.yearMonth.year()}-${plan.yearMonth.month() + 1}`,'YYYY-MM');
                    if(firstStartSiteDate){
                        if(curAddDate < moment(firstStartSiteDate,'YYYY-MM') && plan.isAdd){
                            message.error('项目随机（入组）计划月份不可小于中心计划启动月份');
                            return;
                        }
                        if(curAddDate > moment(invPlanEndDate,'YYYY-MM')){
                            message.error('项目随机（入组）计划月份不可大于项目计划结束月份');
                            return;
                        }
                    }
                    else{
                        if(curAddDate < moment(invPlanBeginDate,'YYYY-MM')){
                            message.error('项目随机（入组）计划月份不可小于项目计划开始月份');
                            return;
                        }
                        if(curAddDate > moment(invPlanEndDate,'YYYY-MM')){
                            message.error('项目随机（入组）计划月份不可大于项目计划结束月份');
                            return;
                        }
                    }
                    const url = (plan.investigationMonthlyPlanId && plan.investigationMonthlyPlanId > 0)
                        ? API_URL.plan.modifyMonthlyPlan : API_URL.plan.addMonthlyPlan;
                    const sendParams = {};
                    sendParams[`monthlyPlanDtos[0].year`] = plan.yearMonth.year();
                    sendParams[`monthlyPlanDtos[0].month`] = plan.yearMonth.month() + 1;
                    sendParams[`monthlyPlanDtos[0].planAmount`] = plan.planAmount;
                    const options = {
                        url,
                        data: {
                            year: plan.yearMonth.year(),
                            month: plan.yearMonth.month() + 1,
                            statisticalType:activeKey,
                            planAmount: plan.planAmount,
                            visitGroupingId,
                            ...sendParams,
                        },
                        dataType: 'json',
                        doneResult: () => {
                            plan.monthlyPlanIsEditing = false;
                            this.setState({ monthlyPlan }, () => {
                                this.loadData();
                            });
                        },
                    };
                    $.sendRequest(options);
                } else {
                    plan.monthlyPlanIsEditing = true;
                    this.setState({ monthlyPlan });
                }
                return;
            }
        });
    }

    delDefinePlan = planIndex => {
        const { monthlyPlan, activeKey, visitGroupingId } = this.state;
        monthlyPlan.map((plan, i) => {
            if (plan.planIndex == planIndex) {
                // 删除
                if (plan.investigationMonthlyPlanId && plan.investigationMonthlyPlanId > 0) {
                    const options = {
                        url: `${API_URL.plan.deleteMonthlyPlan}`,
                        data: {
                            statisticalType:activeKey,
                            year: plan.yearMonth.year(),
                            month: plan.yearMonth.month() + 1,
                            planAmount: plan.planAmount,
                            visitGroupingId,
                        },
                        dataType: 'json',
                        doneResult: () => {
                            monthlyPlan.splice(i, 1);
                            this.setState({ monthlyPlan }, () => {
                                this.loadData();
                            });
                        },
                    };
                    $.sendRequest(options);
                } else {
                    monthlyPlan.splice(i, 1);
                    this.setState({ monthlyPlan });
                }
                return;
            }
        });
    }

    export = () => {
        const { activeKey, blindInvId } = this.state;
        ExportUtil.export({ statisticalType:activeKey, blindInvId }, null, API_URL.export.exportInvestigationPlan);
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            data: [],
            activeKey,
        }, () => {
            this.loadData();
        });
    }

    handleSubTabsChange = (activeKey) => {
        this.setState({
            data: [],
            visitGroupingId:activeKey,
            invPlanIsEdit:false,
        }, () => {
            this.loadData();
        });
    }

    disabledDate = (current) => {
        const { startDate: { invPlanBeginDate, invPlanEndDate } } = this.state;
        return current.valueOf() < moment(invPlanBeginDate).add(-1, 'M').valueOf() || current.valueOf() > moment(invPlanEndDate).valueOf();
    }

    getJoinContent = () => {
        const { monthlyPlan, invPlanIsEdit, plan, visitGroupingList =[], visitGroupingId, activeKey, isGivenSecondLines, isShowInvPlan, givenSecondLinesCanEdit, secondLines, blindInvId, sitePlanFteCal } = this.state;
        const { curRole, investigationSiteName } = sessionStorage;
        const showOperator = !(secondLines === '非盲' && !!blindInvId);
        const dateDisabled = (secondLines === '启动前协助+启动后常规CRC执行' || secondLines === '启动后常规CRC执行') && sitePlanFteCal;
        const canAdd = isGivenSecondLines ? (givenSecondLinesCanEdit && showOperator) : showOperator;
        return (
            <div>
                {
                    activeKey == 'Type_Random' && 
                    <Tabs activeKey={visitGroupingId} onChange={this.handleSubTabsChange}>
                        {visitGroupingList.map(item=>{
                            return(
                            <TabPane tab={item.visitGroupingName} key={String(item.visitGroupingId)}></TabPane>
                            )
                        })}
                    </Tabs>
                }
            <div className='table' style={{position:'relative'}}>
                 <div className='bar'></div>
                <Row type="flex" justify="space-around" align="bottom" className='row1'>
                    <Col span={4} offset={4} style={{ paddingBottom: 8 }}>总计划数</Col>
                    <Col span={16}>
                        <Row style={{ fontWeight: 'bold' }}>
                            <Col span={10}>时间</Col>
                            <Col span={6}>计划数</Col>
                            {(showOperator && !isShowInvPlan) && <Col span={8}>操作</Col>}
                        </Row>
                        <Row>
                            <Col span={10}>-</Col>
                            <Col span={6}><InputNumber value={plan.planAmount} min={0} precision={0} disabled={!invPlanIsEdit} onChange={this.onInputPlanAmount} /></Col>
                            {
                                (showOperator && !isShowInvPlan) &&
                                <Col span={8}><a onClick={() => this.editInvPlan()}>{invPlanIsEdit ? '保存' : '修改'}</a></Col>
                            }
                        </Row>
                    </Col>
                </Row>
                <Row type="flex" justify="space-around" align="bottom" className='row3'>
                    <Col span={4} offset={4} style={{ paddingBottom: 8 }}>实际随机（入组）数</Col>
                    <Col span={16}>
                        <Row>
                            <Col span={10}>-</Col>
                            <Col span={6}>{plan.actualAmount}</Col>
                        </Row>
                    </Col>
                </Row>
                <Row type="flex" justify="space-around" align="bottom" className='row3'>
                    <Col span={4} offset={4} style={{ paddingBottom: 8 }}>入组周期</Col>
                    <Col span={16}>
                        <Row>
                            {
                                // (isGivenSecondLines && isGivenInvStage) ? <Col span={10}>
                                //     {plan.batchLeftYear}.{plan.batchLeftMonth}-{plan.batchRightYear}.{plan.batchRightMonth}
                                // </Col> 
                                // :
                                <Col span={10}>
                                    <MonthPicker
                                        style={{width:100}}
                                        value={(plan.batchLeftYear && plan.batchLeftMonth) ? moment(`${plan.batchLeftYear}-${plan.batchLeftMonth}`) : undefined}
                                        onChange={value=>this.onSelectJoinGroupMonth(value,'startDate')}
                                        disabled={dateDisabled && plan.batchLeftYear && plan.batchLeftMonth}
                                        format={monthFormat}
                                        allowClear={false}
                                        disabledDate={isGivenSecondLines ? this.disabledDate : undefined}
                                    />~
                                    <MonthPicker
                                        style={{width:100}}
                                        value={(plan.batchRightYear && plan.batchRightMonth) ? moment(`${plan.batchRightYear}-${plan.batchRightMonth}`) : undefined}
                                        onChange={value=>this.onSelectJoinGroupMonth(value,'endDate')}
                                        disabled={dateDisabled && plan.batchRightYear && plan.batchRightMonth}
                                        format={monthFormat}
                                        allowClear={false}
                                        disabledDate={isGivenSecondLines ? this.disabledDate : undefined}
                                    />  
                                </Col>
                            }
                            <Col span={6}>
                                <InputNumber disabled = {!showOperator} value={plan.batchPlanAmount || 0} precision={0} onChange={this.onInputBatchPlanAmount} />
                            </Col>
                            <Col span={8}>{(canAdd || isGivenSecondLines) && <Button type="primary" onClick={() => this.canEditByInvStatus(this.addUpdateMonthly)}>添加\更新</Button>}</Col>
                        </Row>
                    </Col>
                </Row>
                <Row type="flex" justify="space-around" align="top" className='row4'>
                    <Col span={4} offset={4}>
                        {
                            canAdd && <Button type="primary" className='fixbtn' onClick={() => this.canEditByInvStatus(this.addMonthly)}>添加</Button>
                        }
                    </Col> 
                    <Col span={16}>
                        {
                            monthlyPlan.map((plan, i) => (
                                <Row key={plan.planIndex}>
                                    <Col span={10}>
                                        <MonthPicker
                                            value={plan.yearMonth}
                                            onChange={this.onSelectMonth.bind(this, plan.planIndex)}
                                            disabled={isGivenSecondLines ? !givenSecondLinesCanEdit : !plan.monthlyPlanIsEditing}
                                            format={monthFormat}
                                            allowClear={false}
                                            disabledDate={isGivenSecondLines ? this.disabledDate : undefined}
                                        />
                                    </Col>
                                    <Col span={6}>
                                        <InputNumber
                                            min={0}
                                            max={1000000}
                                            precision={0}
                                            value={plan.planAmount}
                                            disabled={isGivenSecondLines ? !givenSecondLinesCanEdit : !plan.monthlyPlanIsEditing}
                                            onChange={this.onInputMonthPlan.bind(this, plan.planIndex)}
                                        />
                                    </Col>
                                    {
                                        showOperator &&
                                        <Col span={8}>
                                            {!isGivenSecondLines && <a onClick={() => this.canEditByInvStatus(() => this.saveDefinePlan(plan.planIndex))}>{plan.monthlyPlanIsEditing ? '保存' : '修改'}</a>}
                                            {!isGivenSecondLines && <span className="ant-divider" />}
                                            {!isGivenSecondLines && <Popconfirm title='确定要删除吗?' onConfirm={() => this.canEditByInvStatus(() => this.delDefinePlan(plan.planIndex))} okText="确定"
                                                cancelText="取消">
                                                <a >删除</a>
                                            </Popconfirm>}

                                            {(isGivenSecondLines && givenSecondLinesCanEdit) && <Popconfirm title='确定要删除吗?' onConfirm={() => this.delMonthlyPlanRow(i)} okText="确定"
                                                cancelText="取消">
                                                <a >删除</a>
                                            </Popconfirm>}
                                        </Col>
                                    }
                                </Row>
                            ))
                        }
                    </Col>
                </Row>
                <Row type="flex" justify="space-around" align="top" className='row'>
                    <Col span={4} offset={4}>每月合计</Col>
                    <Col span={16}>
                        <Row>
                            <Col span={10}></Col>
                            <Col span={6} >
                                <label>{this.getTotalAmount()}</label>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <div>
                    { (isGivenSecondLines && showOperator) && 
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                        {
                            (givenSecondLinesCanEdit) ?
                                <div style={{ textAlign: 'center'}}>
                                    <Button
                                        key="save"
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginLeft: 20 }}
                                        onClick={() => this.saveMonthlyPlanRow()}
                                    >保存</Button>
                                    <Button
                                        key="cancle"
                                        type="primary"
                                        style={{ marginLeft: 20 }}
                                        onClick={() => this.givenSecondLinesCancel()}
                                    >取消</Button>
                                </div>
                            :
                                <div style={{ textAlign: 'center' }}>
                                    <Button
                                        key="edit"
                                        type="primary"
                                        style={{ marginLeft: 20 }}
                                        onClick={() => this.changeEdit(true)}
                                    >编辑</Button>
                                </div>
                        }
                    </div>
                    }
                    
                </div>
        </div>
        </div>
        );
    }

    delMonthlyPlanRow = (index) => {
        const { monthlyPlan } = this.state;
        monthlyPlan.splice(index, 1);
        this.setState({ monthlyPlan });
    }

    changeEdit = (value) => {
        const { monthlyPlan } = this.state;
        monthlyPlan.map(plan => {
            plan.monthlyPlanIsEditing = value;
        });
        this.setState({ 
            monthlyPlan,
            givenSecondLinesCanEdit: value,
        });
    }

    givenSecondLinesCancel = () => {
        const { monthlyPlan } = this.state;
        monthlyPlan.map(plan => {
            plan.monthlyPlanIsEditing = false;
        });
        this.setState({ 
            monthlyPlan,
            givenSecondLinesCanEdit: false,
        },() => {
            this.loadData();
        });
    }

    getColumns = () => {
        const { monthlyPlan, activeKey } = this.state;
        //const shouldFixed = (monthlyPlan || []).length > 0;
        const columns = [{
            title: '总体计划',
            dataIndex: 'planAmount',
            key: 'planAmount',
            width: 120,
            fixed: 'left',
        },  {
            title: `实际${activeKey == 'Type_Filter' ? '筛选': activeKey == 'Type_Informed' ? '知情': activeKey == 'Type_Random' ? '随机(入组)':''}数`,
            dataIndex: 'actualAmount',
            key: 'actualAmount',
            width: 110,
            fixed: 'left',
        },{
            title: '按月计划合计',
            dataIndex: 'monthlyPlanTotalAmount',
            key: 'monthlyPlanTotalAmount',
            width: 120,
            fixed: 'left',
        }];
        (monthlyPlan||[]).forEach(item => {
            const { year, month } = item;
            columns.push({
                title: `${year}.${month}`,
                dataIndex: `${year}.${month}`,
                key: `${year}.${month}`,
                width: 80,
            });
        });
        // const { curRole, investigationSiteName } = sessionStorage;
        // if (curRole == 'PM' || curRole == 'PA' || (!investigationSiteName && curRole == 'CTA')) {
        //     columns.push({
        //         title: '操作',
        //         key: 'operation',
        //         fixed: shouldFixed && 'right',
        //         width: 60,
        //         render: (text, record) => {
        //             const { investigationSiteId, } = record;
        //             return (
        //                 <a onClick={() => this.canEditByInvStatus(() => this.setSitePlan(investigationSiteId))}>{!investigationSiteName ? '设置' : '调整'}</a>
        //             );
        //         }
        //     });
        // }
        return columns;
    }

    getDataSource = () => {
        const { plan, monthlyPlan } = this.state;
        const params = {
            ...plan,
        };
        if (monthlyPlan && Array.isArray(monthlyPlan)) {
            monthlyPlan.forEach(item => {
                const { year, month, planAmount } = item;
                params[`${year}.${month}`] = planAmount;
            });
        }
        return [params];
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }
    // 筛选失败率
    editFilterFailureRate = ()=>{
        this.setState({
            failterRoteModal:true
        })
    }
    cancelFilterFailureRate = ()=>{
        const { plan, oldFilterFailureRate } = this.state;
        plan.filterFailureRate = oldFilterFailureRate;
        this.setState({
            failterRoteModal:false,
            plan
        })
    }
    saveFilterFailureRate = ()=>{
        const { activeKey, plan } = this.state;
        const { filterFailureRate } = plan || {};
        const options = {
            method: 'POST',
            url: API_URL.plan.modifyFailureRate,
            data: { filterFailureRate, statisticalType : activeKey },
            dataType: 'json',
            doneResult: res => {
                if(res && res.error)
                {
                    message.error('更新失败');
                    return;
                }
                message.success('更新成功');
                this.loadData();
                this.cancelFilterFailureRate();
            },
        };
        $.sendRequest(options);
    }
    onInputFailureRate = value => {
        const { plan } = this.state;
        plan.filterFailureRate = value;
        this.setState({ plan });
    }
    // 更新图表的调用
    reRenderChart = ()=>{
        this.setState({
            showChart:false,
        },()=>this.setState({
            showChart:true,
        }))
    }

    getContent = ()=>{
        const { loading, pagination, sortParams, activeKey, plan, failterRoteModal, secondLines, blindInvId } = this.state;
        const { filterFailureRate } = plan || {};
        const { curRole, investigationSiteName  } = sessionStorage;
        const showOperator = !(secondLines === '非盲' && !!blindInvId);
        return (
            <div style={{padding:'10px'}}>
                {
                    activeKey == 'Type_Filter' && 
                    <div style={{marginBottom:6}}>
                        {
                            !failterRoteModal ? <div>筛选失败率：
                                {`${filterFailureRate}%`}&nbsp;&nbsp;
                                {
                                  showOperator && <a onClick={()=>this.canEditByInvStatus(() => this.editFilterFailureRate())}><i className="icon iconfont" style={{ fontSize:12 }}>&#xe6a1;</i>&nbsp;修改</a>
                                }
                            </div>
                            : <div>筛选失败率：
                                <InputNumber value={filterFailureRate} precision={2} onChange={this.onInputFailureRate} />&nbsp;%&nbsp;&nbsp;
                                <a onClick={this.saveFilterFailureRate}>保存</a>&nbsp;&nbsp;
                                <a onClick={this.cancelFilterFailureRate}>取消</a>
                            </div>
                        }
                       
                    </div>
                }
                <TableC
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    data={this.getDataSource()}
                    //pagination={pagination}
                    onChange={this.handleTableChange}
                    rowKey="investigationSiteId"
                />
            </div>
        )
    }

    render() {
        const { activeKey, plan, showChart, isShowInvPlan, isGivenSecondLines, secondLines, blindInvId } = this.state;
        const selKey = activeKey + '_Inv';
        const title = '项目执行计划';
        //(activeKey === 'Type_Filter' && '项目筛选计划') || (activeKey === 'Type_Informed' && '项目知情计划') || (activeKey === 'Type_Random' && '项目随机(入组)计划')
        const { curRole, investigationSiteName } = sessionStorage;
        const showOperator = !(secondLines === '非盲' && !!blindInvId);
        return (
            <div className="content">
                <Sider selectKey={selKey} />
                <div className="main">
                    <div className="breadcrumb-bar tac">
                        <Row type="flex" align="bottom">
                            <Col span={10} style={{textAlign:'left',color:'red'}}>
                                {showOperator && <span>已同步配套盲态项目的随机（入组）计划</span>}</Col>
                            <Col span={8}> <h2 className="title">{title}</h2></Col>
                            <Col span={6} style={{textAlign:'right'}}><Button type="primary" onClick={this.export}>导出</Button></Col>
                        </Row>
                    </div>
                    <div className='box' style={{border:'none'}}>
                        <Tabs activeKey={activeKey} onChange={this.handleTabsChange} type="card" className={showOperator ? 'randomStyle' : ''}>
                            {!isShowInvPlan && <TabPane tab="知情计划" key="Type_Informed">{this.getContent()}</TabPane>}
                            {!isShowInvPlan && <TabPane tab="筛选计划" key="Type_Filter">{this.getContent()}</TabPane>}
                            <TabPane tab="随机(入组)计划" key="Type_Random" className='childRandomStyle'>{this.getJoinContent()}</TabPane>
                        </Tabs>
                    </div>
                    <div>
                        {
                            showChart && <PlanChart plan ={plan} blindInvId={blindInvId} isGivenSecondLines={isGivenSecondLines}></PlanChart>
                        }
                    </div>
                </div> 
            </div>
        );
    }
}

export default Investigation;



// WEBPACK FOOTER //
// ./src/components/plan/Investigation.js